
export function getUrlParam(key) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(getKey(key));
}

export function getKey(searchString) {
  const urlParams = new URLSearchParams(window.location.search);
  for (var key of urlParams.keys()) {
    if (searchString.toLowerCase() === key.toLowerCase()) {
      return key;
    }
  }
  return searchString;
}


export function convertUrl(url, order) {
  if (!url || url === "https://"|| url === "123") return "";
  try {
    var newUrl = new URL(url);
    let params = newUrl.search;
    if (/\[badgeno\]|\[clientkey\]/gi.test(params)) {
      if (order) {
        params = params.replace(/\[badgeno\]|\[clientkey\]/gi, order.badgeNo);
      }
      else {
        params = params.replace(/\[badgeno\]|\[clientkey\]/gi, "").replace(/&?badgeno=|&?clientkey=/gi, "");
      }
      let basicUrl = newUrl.origin + newUrl.pathname + params;
      return basicUrl;
    }
  }
  catch (err) {
    return url;
  }
  return url;
}